export function SortableHeader({
  children,
  className = "",
  column,
  sort,
  toggleSort,
}) {
  const active = sort.key === column;

  return (
    <th
      aria-sort={
        active
          ? sort.direction === "asc"
            ? "ascending"
            : "descending"
          : "none"
      }
      className={className}
    >
      <button
        className={`sortable-header${active ? " is-active" : ""}`}
        onClick={() => toggleSort(column)}
        type="button"
      >
        <span>{children}</span>
        <span aria-hidden="true" className="sortable-header__indicator">
          {active ? (sort.direction === "asc" ? "▲" : "▼") : "↕"}
        </span>
      </button>
    </th>
  );
}
